/**
 * Feature flags côté client (Lot 7).
 *
 * Résolution :
 * 1. Variable d'env `VITE_IA_V2_ENABLED` (build-time, Vercel).
 * 2. Override `localStorage[ia_v2_enabled]` (runtime, pour staging
 *    sans rebuild). Le user dev peut basculer la v2 via la console.
 * 3. Défaut : `false` (v1 reste le chemin de production).
 *
 * Pourquoi pas un context React ? Le flag est lu UNE FOIS par page,
 * pas réactivement changé. Une simple fonction suffit, et un context
 * forcerait un Provider en racine pour zéro bénéfice.
 */

function _readEnvFlag(): boolean | null {
  const raw = (import.meta.env.VITE_IA_V2_ENABLED as string | undefined)?.toLowerCase();
  if (raw === "true" || raw === "1") return true;
  if (raw === "false" || raw === "0") return false;
  return null;
}

function _readLocalStorageFlag(): boolean | null {
  try {
    const ls = window.localStorage.getItem("ia_v2_enabled");
    if (ls === "true") return true;
    if (ls === "false") return false;
  } catch {
    // SSR ou localStorage indisponible (mode incognito strict, etc.)
  }
  return null;
}

export function isIaV2Enabled(): boolean {
  const envFlag = _readEnvFlag();
  if (envFlag !== null) return envFlag;
  const lsFlag = _readLocalStorageFlag();
  if (lsFlag !== null) return lsFlag;
  return false;
}

/**
 * Permet à un utilisateur (typiquement un compliance officer en
 * staging) de basculer v2 ON/OFF sans redéploiement. La préférence
 * survit à un refresh de page.
 */
export function setIaV2EnabledLocal(enabled: boolean): void {
  try {
    window.localStorage.setItem("ia_v2_enabled", String(enabled));
  } catch {
    // ignore (cf. above)
  }
}
